'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var HttpInterface =
/*#__PURE__*/
function () {
  function HttpInterface(options) {
    this.SessionStoreCookieFactory = options.sessionStoreCookieFactory;
    this.apiPrefix = options.apiPrefix;
    this.httpParams = options.httpParams;
  }

  var _proto = HttpInterface.prototype;

  _proto.get = function get() {
    throw new Error('HttpApiInterface: Do not directly use this class');
  };

  _proto.post = function post() {
    throw new Error('HttpApiInterface: Do not directly use this class');
  };

  _proto.put = function put() {
    throw new Error('HttpApiInterface: Do not directly use this class');
  };

  _proto.del = function del() {
    throw new Error('HttpApiInterface: Do not directly use this class');
  };

  _proto._getAuthorization = function _getAuthorization(path) {
    if (this.httpParams && this.httpParams.authorization) {
      return this.httpParams.authorization;
    }

    return this._getSessionStoreCookie(path).get('access');
  };

  _proto._getSessionStoreCookie = function _getSessionStoreCookie(path) {
    if (!this.sessionStoreCookie) {
      this.sessionStoreCookie = new this.SessionStoreCookieFactory({
        apiTimeout: 10,
        apiEndpoint: "" + this.apiPrefix + path
      });
    }

    return this.sessionStoreCookie;
  };

  return HttpInterface;
}();

exports.HttpInterface = HttpInterface;